import { xhrApiClient } from '@/config/xhrApiClient'
import { API_EGIFT_INFO } from '@/config/xhrApiClientRouteNames'

export type TEgiftInfoResponse = {
    message?: string | null
    error?: string | null
    data?: TEgiftInfo | null
}

export type TEgiftInfo = {
    status: string
    amount: number
    date_created: string
    description: string
    image: string
    instructions: string
    merchant_id: string
    message?: string | null
    terms: string
    brand_name?: string | null
    brand_image?: string | null
    code?: string | null
    pin?: string | null
    barcode?: string | null
    expiration_date?: string | null
}

const fetchEgift = async (uuid: any): Promise<TEgiftInfoResponse> => {
    const route = `${API_EGIFT_INFO}/${uuid}`
    const response = await xhrApiClient.get(route)
    return response.data
}

export default fetchEgift
